import { useState } from 'react'
import { Check, Share2 } from 'lucide-react'
import { trackEvent } from '../../services/analytics'
import { withUtm } from '../../services/utm'
import './synthesisShareButton.css'

type SynthesisShareButtonProps = {
  href: string
  title: string
  text: string
  placement: string
  label?: string
  className?: string
}

export function SynthesisShareButton({ href, title, text, placement, label = 'SHARE', className = '' }: SynthesisShareButtonProps) {
  const [copied, setCopied] = useState(false)

  const share = async () => {
    const url = withUtm(href, { source: 'reader_share', campaign: 'omikina_synthesis', content: placement })
    try {
      if (typeof navigator.share === 'function') {
        await navigator.share({ title, text, url: url.toString() })
        trackEvent('synthesis_share', { placement, method: 'native', path: url.pathname })
        trackEvent('share', { content_type: 'ai_synthesis', item_id: url.pathname, method: 'native' })
        return
      }
      await navigator.clipboard.writeText(url.toString())
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1800)
      trackEvent('synthesis_share', { placement, method: 'clipboard', path: url.pathname })
      trackEvent('share', { content_type: 'ai_synthesis', item_id: url.pathname, method: 'clipboard' })
    } catch {
      // Native share can be cancelled without turning the page into an error state.
    }
  }

  return <button type="button" className={`synthesis-share ${className}`.trim()} onClick={share} aria-label={`${label}: ${title}`}>{copied ? <Check aria-hidden="true"/> : <Share2 aria-hidden="true"/>}<span>{copied ? 'Link copied' : label}</span></button>
}
